import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.462 0 0 4.462 0 10s4.462 10 10 10 10-4.462 10-10S15.538 0 10 0Z"
      fill="#FFE500"
    />
    <path d="M8.728 11.39h3.196v4.261H8.728v-4.26Z" fill="#fff" />
    <path d="m10.326 5 4.612 6.391H5.714L10.326 5Z" fill="#fff" />
  </svg>
);

export default SvgComponent;
